// extracted by mini-css-extract-plugin
export default {"Placeholder":"waitView_Placeholder__hVWvO","WatiingRender":"waitView_WatiingRender__oUmsv","Mask":"waitView_Mask__8h6u7"};